const namespaced = true
import api from '../../api/vouchers.js';

const state = {
    loadingRequest: false,
    loadinApplication: false,
    evidences: null,
    entity_type: null,
    loadingEvidences: false,
    authorizations: [],
    request: {
        request_code: null,
        whs_data: {},
        const_center_code: {},
        user_code: null,
        applicant_name: null,
        date: null,
        itm_grp_code: null,
        lines: [],
    },
    voucher: [],
    unitsOfMeasurement: [],
    loadingAuthorizations: false,
}
const mutations = {
    SET_REQUEST_ITEM_GROUP(state, request) {
        state.request.itm_grp_code = request
    },
    SET_REQUEST_WHS_DATA(state, request) {
        state.request.whs_data = request
    },
    SET_REQUEST_APPLICANT_NAME(state, request) {
        state.request.applicant_name = request
    },
    SET_REQUEST_CONST_CENTER_CODE(state, request) {
        state.request.const_center_code = request
    },
    SET_REQUEST_USER_CODE(state, request) {
        state.request.user_code = request
    },
    SET_REQUEST_DATE(state, request) {
        state.request.date = request
    },
    SET_REQUEST_LINES(state, request) {
        state.request.lines = request
    },
    SET_REQUEST_RESET(state) {
        state.request.request_code = null,
            state.request.whs_data = {},
            state.request.const_center_code = {},
            state.request.user_code = null,
            state.request.applicant_name = null,
            state.request.date = null,
            state.request.itm_grp_code = null,
            state.request.lines = []
    },
    SET_REQUEST_VOUCHER(state, request) {
        state.voucher = request;
    },
    SET_REQUEST_CODE(state, request) {
        state.request_code = request
    },
    SET_LOADING_REQUEST(state, request) {
        state.loadingRequest = request
    },
    SET_LOADING_APPLICATION(state, request) {
        state.loadinApplication = request
    },
    SET_EVIDENCES(state, request) {
        state.evidences = request;
    },
    SET_ENTITY_TYPE(state, request) {
        state.entity_type = request;
    },
    SET_UNITS(state, request) {
        state.unitsOfMeasurement = request;
    },
    SET_LOADING_EVIDENCES(state, request) {
        state.loadingEvidences = request;
    },
    SET_AUTHORIZATIONS(state, request) {
        state.authorizations = request;
    },
    SET_LOADING_AUTH(state, request) {
        state.loadingAuthorizations = request;
    },
}
const actions = {
    setRequestItemGroup(context, request) {
        context.commit('SET_REQUEST_ITEM_GROUP', request)
    },
    setRequestWhsData(context, request) {
        context.commit('SET_REQUEST_WHS_DATA', request)
    },
    setRequestApplicantName(context, request) {
        context.commit('SET_REQUEST_APPLICANT_NAME', request)
    },
    setRequestCostcenterCode(context, request) {
        context.commit('SET_REQUEST_CONST_CENTER_CODE', request)
    },
    setRequestUserCode(context, request) {
        context.commit('SET_REQUEST_USER_CODE', request)
    },
    setRequestDate(context, request) {
        context.commit('SET_REQUEST_DATE', request)
    },
    setRequestLines(context, request) {
        context.commit('SET_REQUEST_LINES', request)
    },
    setRequestReset(context) {
        context.commit('SET_REQUEST_RESET')
    },

    getVoucher(context) {
        context.commit('SET_LOADING_REQUEST', true);
        return new Promise((resolve) => {
            api.getVoucher().then(function (res) {
                context.commit('SET_REQUEST_VOUCHER', res.data.data);
                resolve(res.data.data);
                context.commit('SET_LOADING_REQUEST', false);
            }).catch((e) => {
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
                context.commit('SET_LOADING_REQUEST', false);
            })
        })
    },
    emptyVoucher(context){
        context.commit('SET_REQUEST_VOUCHER', []);
    },


    store(context, data) {
        context.commit('SET_LOADING_APPLICATION', true);
        return new Promise((resolve, reject) => {
            api.store(data).then(resp => {
                resolve(resp.data);
                context.commit('SET_LOADING_APPLICATION', false);
            }).catch((e) => {
                reject(e)
                context.commit('SET_LOADING_APPLICATION', false);
            })
        });
    },
    storeSAP(context, data) {
        context.commit('SET_LOADING_APPLICATION', true);
        return new Promise((resolve, reject) => {
            api.storeSAP(data).then(resp => {
                resolve(resp.data);
                context.commit('SET_LOADING_APPLICATION', false);
            }).catch((e) => {
                reject(e)
                context.commit('SET_LOADING_APPLICATION', false);
            })
        });
    },
    getEvidences(context, data) {
        context.commit('SET_LOADING_EVIDENCES', true);
        return new Promise((resolve, reject) => {
            api.getEvidences(data).then(resp => {
                context.commit('SET_EVIDENCES', resp.data.data);
                resolve(resp.data.data);
                context.commit('SET_LOADING_EVIDENCES', false);
            }).catch((e) => {
                reject(e);
                context.commit('SET_LOADING_EVIDENCES', false);
            })
        });
    },
    setEntityType(context, data) {
        context.commit('SET_ENTITY_TYPE', data);
    },
    getUnitsOfMeasurement(context) {
        return new Promise((resolve, reject) => {
            api.getUnitsOfMeasurement().then(resp => {
                context.commit('SET_UNITS', resp.data);
                resolve(resp.data);
            }).catch((e) => {
                reject(e)
            })
        });
    },
    getAuthorizations(context) {
        context.commit('SET_LOADING_AUTH', true);
        return new Promise((resolve, reject) => {
            api.getAuthorizations().then(resp => {
                context.commit('SET_AUTHORIZATIONS', resp.data.data);
                resolve(resp.data.data);
                context.commit('SET_LOADING_AUTH', false);
            }).catch((e) => {
                reject(e)
                context.commit('SET_LOADING_AUTH', false);
            })
        });
    },
    updateVoucher(context, data){
        context.commit('SET_LOADING_AUTH', true);
        return new Promise((resolve, reject) => {
            api.updateVoucher(data).then(resp => {
                resolve(resp.data.data);
                context.dispatch('getAuthorizations');
            }).catch((e) => {
                context.commit('SET_LOADING_AUTH', false);
                reject(e)
            })
        });
    },
    update(context, data) {
        return new Promise((resolve, reject) => {
            api.update(data).then(resp => {
                resolve(resp.data);
            }).catch((e) => {
                reject(e)
            })
        });
    },
    updateCostCenter(context, data) {
        return new Promise((resolve, reject) => {
            api.updateCostCenter(data).then(resp => {
                resolve(resp.data);
            }).catch((e) => {
                reject(e)
            })
        });
    },
    addGoodsIssue(context, data) {
        return new Promise((resolve, reject) => {
            api.addGoodsIssue(data).then(resp => {
                resolve(resp.data);
            }).catch((e) => {
                reject(e)
            })
        });
    },
    updateLine(context, data) {
        return new Promise((resolve, reject) => {
            api.updateLine(data).then(resp => {
                resolve(resp.data);
            }).catch((e) => {
                reject(e)
            })
        });
    },

}
const getters = {
    getRequest(state) {
        return state.request
    },
    getListRequest(state) {
        return state.voucher
    },
    getRequestCode(state) {
        return state.request_code
    }

}

export default {
    namespaced,
    state,
    mutations,
    actions,
    getters,
}